import script from "./readSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./readSearch.vue?vue&type=script&setup=true&lang=js"

import "./readSearch.vue?vue&type=style&index=0&id=9b01d80c&lang=less"

const __exports__ = script;

export default __exports__